import {Button, Form, Input} from "antd";
import {useEffect, useRef} from "react";
import {useUser} from "../context/UserContext";
import ApiService from "../services/ApiService";

export default function EditProfile()
{
    const {user, setUser} = useUser();
    const form = useRef();

    const onFinish = async () => {
        const res = await ApiService.User.EditUser({
            ...form.current.getFieldsValue()
        })

        if(res.success) {
            const u = res.data;
            setUser(u)
        }
    }

    useEffect(() => {
        if(user && user.data) {
            form.current.setFieldsValue({
                ...user.data
            })
        }
    }, [user])

    return (
        <>
            <Form
                ref={form}
                layout={'vertical'}
                onFinish={onFinish}
            >
                <Form.Item
                    name="email"
                    label="E-mail"
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!',
                        },
                        {
                            required: true,
                            message: 'Please input your E-mail!',
                        },
                    ]}
                >
                    <Input style={{width: '100%'}} />
                </Form.Item>

                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <Form.Item
                        style={{flex: 1}}
                        name={'name'}
                        label={'Name'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        style={{flex: 1}}
                        name={'lastname'}
                        label={'Lastname'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Input />
                    </Form.Item>
                </div>

                <Form.Item>
                    <Button type={'primary'} htmlType={'submit'}>
                        Save
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}